export default "__VITE_ASSET__ca4b80ce__"